import axiosAuth from '../../axiosMain';

async function index(data) {
  let response = await axiosAuth.get('/company_auth_clients', data);
  return response.data;
}

export default {
  index,
};
